<div class="flex flex-row-reverse">
  <div class="ml-4 mt-auto">
    <aux-menu
      #site_driver_menu
      [showMenuForExternal]="userHasUploadSiteDriverPermission()"
      [disabled]="workflowCtx.isLocked()"
      [disabledTooltip]="workflowCtx.tooltip()"
    >
      <button
        type="button"
        role="menuitem"
        class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
        (click)="onSiteDriverUploadClick(); site_driver_menu.close()"
      >
        <aux-icon name="Upload" />
        <span class="ml-2">Upload</span>
      </button>
    </aux-menu>
  </div>
  <aux-editable-list-dropdown
    [dropdownFormControl]="curveControl"
    [items]="siteCurveListOptions"
    [label]="'Select a Curve:'"
    [classList]="'w-64'"
    [createBtnLabel]="'Create Blended Curve'"
    (edit)="editCurve($event)"
    (delete)="deleteCurve($event)"
    (create)="editCurve()"
    [editDisabled]="disableModifySiteCurve()"
    [deleteDisabled]="disableModifySiteCurve()"
    [createDisabled]="disableModifySiteCurve()"
    [editDisabledTooltip]="disableModifySiteCurveTooltip()"
    [deleteDisabledTooltip]="disableModifySiteCurveTooltip()"
    [createDisabledTooltip]="disableModifySiteCurveTooltip()"
  />
</div>

@if ((loading$ | async) === true) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if (showEnrollmentSettings()) {
  @if (driverSiteQuery.selectLoading() | async) {
    <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
  }

  @if ((driverSiteQuery.selectLoading() | async) === false) {
    <div class="rounded border border-aux-gray-dark bg-aux-gray-light p-4 py-3">
      <div class="mb-4 flex items-center justify-between">
        <div class="text-lg font-bold text-aux-black">Site Assumptions</div>
        @if ((editMode$ | async) === false) {
          <aux-menu #cat_menu>
            <button
              class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
              role="menuitem"
              (click)="editMode$.next(true); cat_menu.close()"
            >
              <aux-icon name="Pencil" class="mr-2" />
              <span>Edit settings</span>
            </button>
          </aux-menu>
        }
      </div>
      <div
        class="mb-4 grid grid-cols-12 gap-5 whitespace-nowrap border-b pb-2 text-sm"
        [ngClass]="{ 'mr-16': (editMode$ | async) === true, 'pl-3': (editMode$ | async) === false }"
      >
        <div class="col-span-3">Cohort Name</div>
        <div># of Sites</div>
        <div class="col-span-2">First Site Initiated</div>
        <div class="col-span-2">Sites Discontinued</div>
        <div class="col-span-2">Ramp Time (In Weeks)</div>
        <div class="col-span-2">Target Patient Count</div>
      </div>

      @if ((editMode$ | async) === false) {
        <div class="mb-3 ml-3 grid grid-cols-12 gap-5 text-xs">
          @for (ss of driverSiteQuery.selectAll() | async; track ss) {
            <div class="col-span-3">{{ ss.cohort_name }}</div>
            <div>{{ ss.number_of_sites }}</div>
            <div class="col-span-2">{{ ss.first_initiated_date | date }}</div>
            <div class="col-span-2">{{ ss.discontinued_date | date }}</div>
            <div class="col-span-2">{{ ss.ramp_time_in_weeks }}</div>
            <div class="col-span-2">{{ ss.target_patient_count }}</div>
          }
        </div>

        @if (avg$ | async; as avg) {
          <div class="my-5 grid grid-cols-12 gap-10 rounded-md border p-3 text-xs font-medium">
            <span class="col-span-3">Average of All Sites</span>
            <span class="">{{ avg.total_number_of_sites }}</span>
            <span class="col-span-2">{{ avg.first_initiated_date }}</span>
            <span class="col-span-2">{{ avg.discontinued_date }}</span>
            <span class="col-span-2">{{ avg.ramp_time_in_weeks | number: '1.0-0' }}</span>
            <span class="col-span-2">{{ avg.target_patient_count | number: '1.0-0' }}</span>
          </div>
        }
      }

      @if ((editMode$ | async) === true) {
        <form [formGroup]="fg" (ngSubmit)="onSaveAll()">
          @for (set of fg.controls.settings.controls; track set; let i = $index) {
            <ng-container formArrayName="settings">
              @if (set) {
                <div
                  class="relative mb-3 mr-16 grid grid-cols-12 gap-5 text-xs"
                  [formGroupName]="i"
                >
                  <aux-input
                    class="col-span-3"
                    formControlName="cohort_name"
                    validators="required"
                  />
                  <aux-input
                    formControlName="number_of_sites"
                    validators="required"
                    [type]="'number'"
                  />
                  <aux-input
                    class="col-span-2"
                    formControlName="first_initiated_date"
                    validators="required"
                    [type]="'date'"
                  />
                  <aux-input
                    class="col-span-2"
                    formControlName="discontinued_date"
                    validators="required"
                    [type]="'date'"
                  />
                  <aux-input
                    class="col-span-2"
                    formControlName="ramp_time_in_weeks"
                    validators="required"
                    [type]="'number'"
                  />
                  <aux-input
                    class="col-span-2"
                    formControlName="target_patient_count"
                    validators="required"
                    [type]="'number'"
                  />
                  <button
                    class="btn absolute -right-16 h-12 w-12"
                    type="button"
                    (click)="onRemoveCohort(i, set)"
                  >
                    <aux-icon name="Trash" class="text-aux-error" />
                  </button>
                </div>
              }
            </ng-container>
          }

          <button class="mt-4 flex items-center" type="button" (click)="onAddCohort()">
            <aux-icon name="Plus" class="mr-1 text-aux-blue" />
            <span class="aux-link text-xs">Add Cohort</span>
          </button>

          <div class="mb-5 mt-4 flex items-center space-x-4 text-xs">
            <button type="submit" class="btn btn--blue">
              @if (loading$ | async) {
                <span class="spinner mr-3 h-4 w-4"></span>
              }
              <span>Save Edits</span>
            </button>
            <button class="btn--secondary" type="button" (click)="editMode$.next(false)">
              Cancel
            </button>
          </div>
        </form>
      }
    </div>
  }
}
@if ((loading$ | async) === false) {
  <div class="flex justify-between">
    <div class="mb-4 mt-[25px] text-xl font-bold text-aux-black">Estimated Site Curve</div>
  </div>

  @if (multiChart$ | async; as chart) {
    <aux-canvas-chart [chartOptions]="chart" />
  }

  <div class="mb-5 mt-[25px] flex items-center justify-between space-x-4">
    <div class="text-lg font-bold text-black">Sites Online Estimates</div>
    @if ((this.gridData$ | async)?.length !== 0) {
      <div class="flex justify-end">
        @if (
          (editMode$ | async) === false &&
          (isBlended$ | async) === false &&
          userHasModifyPermissions()
        ) {
          <aux-button
            label="Edit"
            classList="ml-1 btn-secondary"
            variant="secondary"
            icon="Pencil"
            [auxTooltip]="workflowCtx.tooltip()"
            [disabled]="workflowCtx.isLocked()"
            [onClick]="this.onEditClick.bind(this)"
          />
        }
        @if ((editMode$ | async) === true && (isBlended$ | async) === false) {
          <button type="button" class="btn--secondary" (click)="cancelEditMode()">
            <aux-icon name="X" />
            <span class="ml-0.5">Cancel</span>
          </button>
        }

        @if ((editMode$ | async) === true) {
          <aux-button
            label="Save"
            variant="success"
            classList="ml-1"
            [disabled]="
              isSaveBtnDisabled || (isNetSiteNegative$ | async) === true || !wasGridChanged()
            "
            [auxTooltip]="saveBtnTitle()"
            [onClick]="saveEditMode"
            [loading]="(btnLoading$ | async) === true"
            icon="Check"
          />
        }

        <aux-export-excel-button
          className="ml-1"
          [clickFN]="onExportForSiteDriver.bind(this)"
          [spinnerSize]="7"
          pendoTag="forecast-site-curves-excel-export-button"
        />
      </div>
    }
  </div>
  <ag-grid-angular
    class="ag-theme-aux site-table tabular-nums"
    domLayout="autoHeight"
    id="site-table"
    [rowData]="gridData$ | async"
    [gridOptions]="gridOptions"
    [stopEditingWhenCellsLoseFocus]="true"
    [enableFillHandle]="(editMode$ | async) === true"
    (gridReady)="onGridReady($event)"
    (cellValueChanged)="cellValueChanged(); onCellValueChanged()"
    (firstDataRendered)="onDataRendered($event)"
    (cellEditingStarted)="rowPinnedCheck($event)"
    auxStickyGrid
  />
}
